import { InputOTP, InputOTPGroup, InputOTPSlot } from '@/components/ui/input-otp';

export default function OtpCodeInput({ value, onChange, disabled = false, id = 'otp-code', variant = 'default' }) {
  const slotClass =
    variant === 'light'
      ? 'h-12 w-11 sm:w-12 rounded-xl border border-[#e5e7eb] bg-white text-[#111827] text-lg shadow-none'
      : 'h-11 w-11 border-[var(--border-default)] bg-[var(--bg-elev)] text-[var(--text-primary)]';

  return (
    <InputOTP
      id={id}
      maxLength={6}
      value={value}
      onChange={onChange}
      disabled={disabled}
      containerClassName="justify-center"
    >
      <InputOTPGroup className={variant === 'light' ? 'gap-2' : undefined}>
        <InputOTPSlot index={0} className={slotClass} />
        <InputOTPSlot index={1} className={slotClass} />
        <InputOTPSlot index={2} className={slotClass} />
        <InputOTPSlot index={3} className={slotClass} />
        <InputOTPSlot index={4} className={slotClass} />
        <InputOTPSlot index={5} className={slotClass} />
      </InputOTPGroup>
    </InputOTP>
  );
}
